import React, { useEffect } from 'react'
import { Editor } from '@tinymce/tinymce-react';

const EmailEditor = ({ reset = false, disabled = false, initialValue = '', editorChange, ...props }) => {
    const [editorKey, setEditorKey] = React.useState(4);

    useEffect(() => {
        if (!reset) return

        // reset Editor
        const newKey = editorKey * 43;
        setEditorKey(newKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reset])

    return <>
        <Editor
            {...props}
            key={editorKey}
            disabled={disabled}
            apiKey="h8bb037q5830kua1wp4nc1uwfi93uon6xawq25mdmhm32j1t"
            initialValue={initialValue}
            init={{
                height: 500,
                menubar: !disabled,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                ],
                toolbar: disabled ? '' :
                    `undo redo | formatselect | bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | help`
            }}
            onEditorChange={(editorChange)}
        />
    </>
}

export default EmailEditor;